/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetBreadcrumbsV1Response } from '../../entities/breadcrumbs/GetBreadcrumbsV1Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetBreadcrumbsRequest {
  offerType?: EQueryParameters;
  query?: string;
  subdomain: string;
  uri?: string;
}

export enum EQueryParameters {
  /** Коммерческая недвижимость **/
  'Commercial' = 'commercial',
}
export type TGetBreadcrumbsResponse =
  | FetchModelResponse<200, 'json', IGetBreadcrumbsV1Response>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetBreadcrumbsModel = IFetchModel<IGetBreadcrumbsRequest, undefined, TGetBreadcrumbsResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetBreadcrumbsV1Response, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
